import React, { Fragment, useState, useEffect } from "react";
import PortalMenu from "../Common/PortalMenu";
import { Row, Col, Card, Dropdown, Modal, Button, Table, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import AppPagination from "../Common/AppPagination";
import PageTitle from "../../layouts/PageTitle";
import api from "../../../api";
import swal from "sweetalert";

const WarrantyCardsList = () => {
 const [cards, setCards] = useState([]);
 const [selectedCard, setSelectedCard] = useState(null);
 const [showModal, setShowModal] = useState(false);
 const [loading, setLoading] = useState(false);
 const [previewingPdf, setPreviewingPdf] = useState(false);

 const [currentPage, setCurrentPage] = useState(1);
 const itemsPerPage = 10;

 useEffect(() => {
 fetchWarrantyCards();
 }, []);

 const fetchWarrantyCards = async () => {
 try {
 setLoading(true);
 const res = await api.get("/warranty-cards");
 if (res.data.success) {
 setCards(res.data.data || []);
 }
 } catch (err) {
 console.error(err);
 swal("Error", "Failed to load warranty cards", "error");
 } finally {
 setLoading(false);
 }
 };

 // Calculate pagination
 const indexOfLastItem = currentPage * itemsPerPage;
 const indexOfFirstItem = indexOfLastItem - itemsPerPage;
 const currentItems = cards.slice(indexOfFirstItem, indexOfLastItem);
 const totalPages = Math.ceil(cards.length / itemsPerPage);

 const handlePageChange = (pageNumber) => {
 setCurrentPage(pageNumber);
 };

 const handleDownloadPDF = async (id) => {
 try {
 const res = await api.get(`/warranty-cards/download-pdf/${id}`, {
 responseType: "blob"
 });
 const url = window.URL.createObjectURL(new Blob([res.data]));
 const link = document.createElement("a");
 link.href = url;
 link.download = `WARRANTY-${id}.pdf`;
 document.body.appendChild(link);
 link.click();
 link.remove();
 } catch (err) {
 swal("Error", "Failed to download PDF", "error");
 }
 };

 const handlePreviewPDF = async (id) => {
 try {
 setPreviewingPdf(true);
 const res = await api.get(`/warranty-cards/download-pdf/${id}`, {
 responseType: "blob"
 });
 const fileURL = window.URL.createObjectURL(
 new Blob([res.data], { type: "application/pdf" })
 );
 window.open(fileURL, "_blank");
 } catch (err) {
 console.error(err);
 swal("Error", "Failed to preview PDF", "error");
 } finally {
 setPreviewingPdf(false);
 }
 };

 const handleDelete = async (id) => {
 const confirm = await swal({
 title: "Delete warranty card?",
 text: "This action cannot be undone",
 icon: "warning",
 buttons: ["Cancel", "Delete"],
 dangerMode: true
 });
 if (!confirm) return;
 try {
 await api.delete(`/warranty-cards/${id}`);
 swal("Deleted", "Warranty card deleted successfully", "success");
 fetchWarrantyCards();
 } catch (err) {
 swal("Error", "Failed to delete warranty card", "error");
 }
 };

 const handleView = async (id) => {
 try {
 const res = await api.get(`/warranty-cards/${id}`);
 if (res.data.success) {
 setSelectedCard(res.data.data);
 setShowModal(true);
 }
 } catch (err) {
 swal("Error", "Failed to load warranty card", "error");
 }
 };

 const formatDate = (date) => {
 if (!date) return "-";
 return new Date(date).toLocaleDateString("en-IN", {
 day: "2-digit", month: "short", year: "numeric"
 });
 };

 const svgMenu = (
 <svg width="20" height="20" viewBox="0 0 24 24">
 <circle cx="5" cy="12" r="2"></circle>
 <circle cx="12" cy="12" r="2"></circle>
 <circle cx="19" cy="12" r="2"></circle>
 </svg>
 );

 return (
 <Fragment>
 <PageTitle activeMenu="Warranty Cards" motherMenu="Quality" />
 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between align-items-center">
 <Card.Title>Warranty Card List</Card.Title>
 <Link to="/warranty-cards/add" className="btn btn-success">+ Add Card</Link>
 </Card.Header>
 <Card.Body>
 {loading ? (
 <div className="text-center py-5">
 <div className="spinner-border text-primary"></div>
 <p className="mt-2">Loading warranty cards...</p>
 </div>
 ) : cards.length === 0 ? (
 <div className="text-center py-5">
 <p>No warranty cards found</p>
 <Link to="/warranty-cards/add" className="btn btn-primary">+ Add Card</Link>
 </div>
 ) : (
 <>
 <div className="table-responsive" style={{ overflow: "visible" }}>
 <Table hover bordered className="align-middle">
 <thead style={{ backgroundColor: "#ffd0a7" }}>
 <tr>
 <th>#</th>
 <th>Client</th>
 <th>Subject</th>
 <th>Date</th>
 <th className="text-center">Actions</th>
 </tr>
 </thead>
 <tbody>
 {currentItems.map((card, i) => (
 <tr key={card._id}>
 <td>{indexOfFirstItem + i + 1}</td>
 <td><strong>{card.client?.split("\n")[0] || "-"}</strong></td>
 <td>{card.subject || "-"}</td>
 <td>{formatDate(card.warrantyDate)}</td>
 <td className="text-center">
 <Dropdown>
 <Dropdown.Toggle variant="" as="div" className="btn i-false p-0 cursor-pointer">
 {svgMenu}
 </Dropdown.Toggle>
 <Dropdown.Menu align="end" as={PortalMenu}>
 <Dropdown.Item onClick={() => handleView(card._id)}><i className="fas fa-eye me-2"></i>View</Dropdown.Item>
 <Dropdown.Item as={Link} to={`/warranty-cards/edit/${card._id}`}><i className="fas fa-edit me-2"></i>Edit</Dropdown.Item>
 <Dropdown.Item onClick={() => handlePreviewPDF(card._id)} disabled={previewingPdf}><i className="fas fa-eye me-2 text-primary"></i>Preview PDF</Dropdown.Item>
 <Dropdown.Item onClick={() => handleDownloadPDF(card._id)}><i className="fas fa-file-pdf me-2 text-danger"></i>Download PDF</Dropdown.Item>
 <Dropdown.Divider />
 <Dropdown.Item className="text-danger" onClick={() => handleDelete(card._id)}><i className="fas fa-trash me-2"></i>Delete</Dropdown.Item>
 </Dropdown.Menu>
 </Dropdown>
 </td>
 </tr>
 ))}
 </tbody>
 </Table>
 <AppPagination
 currentPage={currentPage}
 totalPages={totalPages}
 totalCount={cards.length}
 itemsLength={currentItems.length}
 limit={itemsPerPage}
 onPageChange={handlePageChange}
 />
 </div>
 </>
 )}
 </Card.Body>
 </Card>
 </Col>
 </Row>

 <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
 <Modal.Header closeButton><Modal.Title className="text-black">Warranty Card Details</Modal.Title></Modal.Header>
 <Modal.Body className="text-black">
 {selectedCard && (
 <>
 <Row className="mb-3">
 <Col md={6}>
 <p className="mb-1 text-black"><strong>Client:</strong></p>
 <div className="border p-2 rounded bg-light text-black" style={{ whiteSpace: "pre-wrap" }}>
 {selectedCard.client || "-"}
 </div>
 </Col>
 <Col md={6}>
 <p className="mb-1 text-black"><strong>Details:</strong></p>
 <div className="border p-2 rounded bg-light text-black">
 <div className="text-black"><strong>Ref No:</strong> {selectedCard.refNo || "-"}</div>
 <div className="text-black"><strong>Date:</strong> {formatDate(selectedCard.warrantyDate)}</div>
 <div className="text-black"><strong>Subject:</strong> {selectedCard.subject}</div>
 </div>
 </Col>
 </Row>

 {selectedCard.topContent && (
 <div className="mt-3 mb-4">
 <h6 className="text-black">Introduction:</h6>
 <div className="border p-3 rounded text-black" dangerouslySetInnerHTML={{ __html: selectedCard.topContent }} />
 </div>
 )}

 <hr className="border-dark opacity-50" />
 <h6 className="mb-3 text-black">Warranty Items:</h6>
 <Table bordered responsive hover className="small text-black">
 <thead style={{ backgroundColor: "#ffd0a7" }}>
 <tr className="text-black">
 <th className="text-black border-dark">#</th>
 <th className="text-black border-dark">Product Name</th>
 <th className="text-black border-dark">Model Number</th>
 <th className="text-black border-dark">Qty</th>
 <th className="text-black border-dark">Serial Range</th>
 <th className="text-black border-dark">Warranty PID</th>
 </tr>
 </thead>
 <tbody>
 {selectedCard.items?.map((it, i) => (
 <tr key={i} className="text-black">
 <td>{i + 1}</td>
 <td>{it.productName}</td>
 <td>{it.modelNo}</td>
 <td>{it.qty}</td>
 <td>{it.serialFrom} - {it.serialTo}</td>
 <td className="fw-bold text-primary">{it.warrantyCode}</td>
 </tr>
 ))}
 </tbody>
 </Table>

 {selectedCard.bottomContent && (
 <div className="mt-4 border-top pt-3">
 <h6 className="text-black">Terms & Conditions:</h6>
 <div className="border p-3 rounded bg-light text-black" dangerouslySetInnerHTML={{ __html: selectedCard.bottomContent }} />
 </div>
 )}
 </>
 )}
 </Modal.Body>
 <Modal.Footer>
 <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
 {selectedCard && (
 <Button variant="danger" onClick={() => handleDownloadPDF(selectedCard._id)}>
 <i className="fas fa-file-pdf me-2"></i>Download PDF
 </Button>
 )}
 </Modal.Footer>
 </Modal>

 {previewingPdf && (
 <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ background: "rgba(0,0,0,0.4)", zIndex: 9999 }}>
 <div className="bg-white p-4 rounded shadow text-center">
 <div className="spinner-border text-primary mb-3"></div>
 <h6 className="mb-0">Preparing Warranty Card PDF…</h6>
 </div>
 </div>
 )}
 </Fragment>
 );
};

export default WarrantyCardsList;
